export default __webpack_public_path__ + "static/media/social_btn_left.8445dc94.svg";